// Texty stránky B2B — slovenské dvojče locale/cs/b2bPage.js. Stránka na SK
// není (`SHOP.pages.b2b` je null), modul se na SK nikdy nespustí
// (pageIs('b2b') === false) — dvojče žije kvůli tvaru (S3 #399).
export default {
  eyebrow: 'Pre firmy a remeselníkov',
  maxOff: (pct) => 'až −' + pct + ' %',
  register: 'Registrácia do B2B programu',
  tiersCta: 'Zobraziť úrovne zliav',
  note: 'Pri registrácii zvoľte typ účtu „veľkoobchodný odberateľ".',
  notePrefix: 'Pri registrácii ',
  how: 'Ako spolupráca funguje',
  howHint: 'V troch krokoch',
  tiers: 'Tri úrovne veľkoobchodnej spolupráce',
  tiersPerex:
    'Úroveň prideľujeme podľa vášho odberu za posledných 12 mesiacov. Čím väčší odber, tým výhodnejšie ceny.',
  best: 'Najvýhodnejšie',
  off: 'zľava',
  fromMoc: 'z maloobchodnej ceny',
  feedTag: 'XML feed',
  feedTagSub: 'pre predpredaj tovaru',
  contactEyebrow: 'Navýšenie spolupráce',
  contactTitle: 'Chcete lepšie podmienky?',
  feedCta: 'Vyžiadať XML feed',
  feedSubject: 'Žiadosť o XML feed',
  steps: [
    {
      title: 'Registrácia odberateľa',
      desc: 'Vytvoríte účet a zvolíte typ „veľkoobchodný odberateľ". Nutné je platné IČO a DIČ.',
    },
    {
      title: 'Schválenie a zaradenie',
      desc: 'Registráciu overíme a podľa vášho odberu vás zaradíme do niektorej z úrovní spolupráce.',
    },
    {
      title: 'Nákup za VO ceny',
      desc: 'Po prihlásení vidíte zvýhodnené veľkoobchodné ceny automaticky pri väčšine sortimentu.',
    },
  ],
  ctaNote: (note) => note.replace(/^zvo[lľ]te/i, (m) => m.toLowerCase()),
};
